export default __webpack_public_path__ + "static/media/Summerdrone.52b6498d.mp4";